import { Stack, Typography, useTheme } from "@mui/material";
import { InfoIcon } from "components";

/**
 * Shown for channels an enterprise MSP can't self-serve from here — the MS
 * Teams app, and iOS until the MSP publishes a build to the App Store.
 */
export const ContactAccountOwnerNotice = () => {
  const theme = useTheme();

  return (
    <Stack
      direction="row"
      alignItems="center"
      gap="8px"
      p="12px 16px"
      borderRadius="8px"
      border={`1px solid ${theme.palette.primitive.system.blue["400"]}`}
      bgcolor={theme.palette.primitive.system.blue["25"]}
    >
      <InfoIcon
        sx={{
          color: theme.palette.primitive.system.blue["800"],
          flexShrink: 0,
        }}
      />
      <Typography
        variant="body-medium"
        color={theme.palette.primitive.system.blue["800"]}
      >
        Contact your account owner
      </Typography>
    </Stack>
  );
};
